module.exports = "/static/assets/7efc16240b399536e9f33961b23ebabd.png";